import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, tap, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CaqRequestService } from '../caq-request/caq-request.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { CHAVES_STORAGE } from '../../constants/storage-keys';

interface AnosReferenciasResponse {
  content: AnosReferenciasDto;
}

@Injectable({
  providedIn: 'root'
})
export class AnosReferenciasService {
  private apiUrl = `${environment.apiUrl}/anos-referencias`;
  private anosReferencias = new BehaviorSubject<AnosReferenciasDto | null>(null);

  constructor(private caqRequestService: CaqRequestService) {
    this.restaurarDoCache();
  }

  carregarAnosReferencias(): Observable<AnosReferenciasDto | null> {
    const cached = this.anosReferencias.getValue();
    if (cached) {
      return of(cached);
    }

    return this.caqRequestService
      .get<AnosReferenciasResponse>(this.apiUrl)
      .pipe(
        map(response => response?.content ?? null),
        tap(dados => {
          if (dados) {
            this.anosReferencias.next(dados);
            sessionStorage.setItem(CHAVES_STORAGE.ANOS_REFERENCIAS, JSON.stringify(dados));
          }
        })
      );
  }

  obterAnosReferencias(): Observable<AnosReferenciasDto | null> {
    return this.anosReferencias.asObservable();
  }

  obterAnosReferenciasSnapshot(): AnosReferenciasDto | null {
    return this.anosReferencias.getValue();
  }

  invalidarCache(): void {
    this.anosReferencias.next(null);
    sessionStorage.removeItem(CHAVES_STORAGE.ANOS_REFERENCIAS);
  }

  private restaurarDoCache(): void {
    const dados = sessionStorage.getItem(CHAVES_STORAGE.ANOS_REFERENCIAS);
    if (dados) {
      this.anosReferencias.next(JSON.parse(dados));
    }
  }
}
